import { gql } from "@apollo/client";

export const COVERAGE_CATEGORIES = gql`
  query CoverageCategories(
    $where: CoverageCategoryWhereInput
    $take: Int
    $skip: Int
    $like: CoverageCategoryWhereInput
    $gt: CoverageCategoryWhereInput
    $orderBy: [CoverageCategoryWhereInput]
  ) {
    coverageCategories(
      where: $where
      take: $take
      skip: $skip
      like: $like
      gt: $gt
      orderBy: $orderBy
    ) {
      data {
        id
        value
        label
        description
        icon
        order
        weight
      }
      count
    }
  }
`;

export const COVERAGE_CATEGORY = gql`
  query CoverageCategory($where: CoverageCategoryWhereInput) {
    coverageCategory(where: $where) {
      id
      value
      label
      description
      icon
      order
      weight
    }
  }
`;

const coverageCategories = { COVERAGE_CATEGORIES, COVERAGE_CATEGORY };

export default coverageCategories;
